/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable object-curly-newline */
/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { ChangeEvent } from "react";

import RadioGroup from "@mui/material/RadioGroup";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import { Theme, SxProps } from "@mui/material/styles";

import { TrainingTypes, TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../Constants";
import valueOf from "../../logic/valueOf";

// Constants.
const SompoSearchModes: { [name: string]: number } = {
    TRAINING_TYPE_CAREER,
    TRAINING_TYPE_CURRICULUM,
};
export type SompoSearchModeValue = valueOf<typeof SompoSearchModes>;

// Utilities.
const modeToLabel = (mode: number) => TrainingTypes[mode];

// Sub Components.
const SearchModeRadio = (props: { mode: number; radioProps?: SxProps<Theme> }) => {
    const { mode, radioProps } = props;
    return (
        <FormControlLabel
            control={<Radio size="small" sx={{ ...radioProps }} />}
            value={mode}
            label={<Typography variant="body2">{modeToLabel(mode)}</Typography>}
        />
    );
};

// Main Component.
const SompoSearchMode = (props: {
    searchMode: SompoSearchModeValue;
    onChangeSelected: (selected: SompoSearchModeValue) => void;
    radioProps?: SxProps<Theme>;
}) => {
    // Props.
    const { searchMode, onChangeSelected, radioProps } = props;

    // Event handlers.
    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const mode = parseInt(event.target.value, 10);
        // console.log("SompoSearchMode: Mode changed.", `${modeToLabel(mode)}(${mode})`);
        onChangeSelected(mode);
    };

    // Render component.
    return (
        <RadioGroup row defaultValue={TRAINING_TYPE_CAREER} value={searchMode} onChange={onChange}>
            {Object.keys(SompoSearchModes).map((name) => {
                const mode = SompoSearchModes[name];
                return <SearchModeRadio mode={mode} key={`SompoSearchMode-SearchModeRadio-${mode}`} radioProps={radioProps} />;
            })}
        </RadioGroup>
    );
};

export default SompoSearchMode;
